import { Component } from '@angular/core';
import { VehicleModelService } from '../services/vehicle-model.service';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { Vehicle } from '../vehicle';
@Component({
  selector: 'app-list-vehicle',
  templateUrl: './list-vehicle.component.html',
  styleUrl: './list-vehicle.component.css',
})
export class ListVehicleComponent {
  search: string = '';
  showModal: boolean = false;
  selectedVehicle: Vehicle | null = null;

  columns = [
    {
      field: 'year',
      title: 'Año',
      headerClass: 'text-black dark:text-white',
      cellClass: 'text-black dark:text-white border border-primary rounded-md p-2  animate__animated animate__zoomIn animate__fadeIn animate__delay-1s',
    },
    {
      field: 'typevehicle',
      title: 'Tipo',
      headerClass: 'text-black dark:text-white',
      cellClass: 'text-black dark:text-white border border-primary rounded-md p-2  animate__animated animate__zoomIn animate__fadeIn animate__delay-1s',
    },
    {
      field: 'marca',
      title: 'Marca',
      headerClass: 'text-black dark:text-white',
      cellClass: 'text-black dark:text-white border border-primary rounded-md p-2  animate__animated animate__zoomIn animate__fadeIn animate__delay-1s',
    },
    {
      field: 'modelo',
      title: 'Modelo',
      headerClass: 'text-black dark:text-white',
      cellClass: 'text-black dark:text-white border border-primary rounded-md p-2  animate__animated animate__zoomIn animate__fadeIn animate__delay-1s',
    },
    {
      field: 'km',
      title: 'Kilometraje',
      headerClass: 'text-black dark:text-white',
      cellClass: 'text-black dark:text-white border border-primary rounded-md p-2  animate__animated animate__zoomIn animate__fadeIn animate__delay-1s',
    },
    {
      field: 'plate',
      title: 'Placa',
      headerClass: 'text-black dark:text-white',
      cellClass: 'text-black dark:text-white border border-primary rounded-md p-2  animate__animated animate__zoomIn animate__fadeIn animate__delay-1s',
    },
    {
      field: 'color',
      title: 'Color',
      headerClass: 'text-black dark:text-white',
      cellClass: 'text-black dark:text-white border border-primary rounded-md p-2  animate__animated animate__zoomIn animate__fadeIn animate__delay-1s',
    },
    {
      field: 'city',
      title: 'Ciudad',
      headerClass: 'text-black dark:text-white',
      cellClass: 'text-black dark:text-white border border-primary rounded-md p-2  animate__animated animate__zoomIn animate__fadeIn animate__delay-1s',
    },
    {
      field: 'action',
      title: 'Acción',
      sort: false,
      headerClass: 'text-black dark:text-white',
      cellClass: 'text-black dark:text-white border border-primary rounded-md p-2  animate__animated animate__zoomIn animate__fadeIn animate__delay-1s',
    },
    {
      field: 'status',
      title: 'Estado',
      headerClass: 'text-black dark:text-white',
      cellClass: 'text-black dark:text-white border border-primary rounded-md p-2  animate__animated animate__zoomIn animate__fadeIn animate__delay-1s',
    },
  ];

  rows: Vehicle[] = [];
  vehicles: Vehicle[] = [];
  constructor(
    private vehicleModelService: VehicleModelService,
    public dialog: MatDialog,
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.loadVehicles();
  }
  ngOnChanges() {
    console.log('Vehículo recibido en el modal:', this.selectedVehicle);
  }

  loadVehicles(): void {
    this.vehicleModelService.getVehicleModels().subscribe((data) => {
      this.rows = data;
    });
  }

  onEdit(vehicle: Vehicle): void {
    const dialogRef = this.dialog.open(ListVehicleComponent, {
      width: '400px',
      data: vehicle,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log('Vehículo actualizado:', result);
        this.loadVehicles();
      }
    });
  }

  onDelete(vehicle: Vehicle): void {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.vehicleModelService.deleteVehicleModel(vehicle._id).subscribe(() => {
          Swal.fire('¡Eliminado!', 'El vehículo ha sido eliminado correctamente.', 'success');
          this.loadVehicles();
        });
      }
    });
  }

  openEditModal(vehicle: Vehicle) {
    this.selectedVehicle = vehicle;
    this.showModal = true;
    console.log('Modal abierto:', this.showModal, 'Vehículo:', this.selectedVehicle);
  }

  updateVehicle(updatedVehicle: Vehicle) {
    console.log('Actualizando vehículo:', updatedVehicle);
  }
  toggleStatus(vehicle: Vehicle): void {
    if (vehicle.status) {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Ten en cuenta que si deshabilitas este vehículo, ya no recibirás notificaciones.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, deshabilitar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          const nuevoStatus = !vehicle.status;
          this.vehicleModelService.updateStatus(vehicle._id, nuevoStatus).subscribe(
            (updatedVehicle: Vehicle) => {
              vehicle.status = updatedVehicle.status;
              console.log('Estado actualizado:', updatedVehicle.status);
              Swal.fire('Deshabilitado', 'El vehículo ha sido deshabilitado.', 'success');
            },
            (error) => {
              console.error('Error actualizando el estado:', error);
            },
          );
        }
      });
    } else {
      const nuevoStatus = !vehicle.status;
      this.vehicleModelService.updateStatus(vehicle._id, nuevoStatus).subscribe(
        (updatedVehicle: Vehicle) => {
          vehicle.status = updatedVehicle.status;
          console.log('Estado actualizado:', updatedVehicle.status);
          Swal.fire('Habilitado', 'El vehículo ha sido habilitado y recibirás notificaciones.', 'success');
        },
        (error) => {
          console.error('Error actualizando el estado:', error);
        },
      );
    }
  }
}
